export default __webpack_public_path__ + "static/media/mobilebanner.2ec4d7de.png";